import { __decorate, __metadata } from "tslib";
import { UseRestraints } from '@core/shared/restraints';
import { AllowHtml, CrudEndpoints, EditorDefinition, Expose, IdItemModel, IsNotEmpty, ItemModelDefinition, ItemModelProp, MinLength, Trim, ModelId } from '@core/shared/model';
import { DocentRestraints } from "./docent.restraints";
import { MEDIA_PROPS_ACCESSOR, MEDIA_PROPS_EDITORDEF, MediaAssets } from '@common/media/shared';
let DocentItem = /*#__PURE__*/(() => {
  let DocentItem = class DocentItem extends IdItemModel {
    toString() {
      return "Docent " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], DocentItem.prototype, "creationDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Number)], DocentItem.prototype, "ownerId", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], DocentItem.prototype, "updateDate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], DocentItem.prototype, "enabled", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), MinLength(3), __metadata("design:type", String)], DocentItem.prototype, "name", void 0);
  __decorate([Expose(), ItemModelProp(), IsNotEmpty({
    message: 'Bitte wählen Sie eine Anrede aus!'
  }), __metadata("design:type", String)], DocentItem.prototype, "gender", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], DocentItem.prototype, "alias", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), AllowHtml(), __metadata("design:type", String)], DocentItem.prototype, "description", void 0);
  DocentItem = __decorate([EditorDefinition('admin', {
    enabled: true,
    name: true,
    gender: true,
    photo: true,
    interview: true,
    behindTheScenes: true,
    description: true,
    ownerId: true,
    [MEDIA_PROPS_ACCESSOR]: MEDIA_PROPS_EDITORDEF
  }, {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/docents'
  }, {
    clientCache: {
      seconds: 15 * 60,
      endpoints: {
        admin: true
      }
    }
  }), ItemModelDefinition({
    texts: {
      item: 'Dozent',
      items: 'Dozenten',
      newItem: 'Neuen Dozenten erstellen'
    }
  }), UseRestraints(DocentRestraints), MediaAssets(['photo', 'interview', 'behind-the-scenes']), ModelId("DocentItem") // auto-generated by generate-model-ids
  ], DocentItem);
  return DocentItem;
})();
export { DocentItem };